import { createForm, useForm } from 'effector-forms';
import { useStore } from 'effector-react';
import React, { ChangeEvent, useEffect } from 'react';
import { FormField, Textarea, TextInput, Button, toaster } from 'evergreen-ui';
import { styled } from 'linaria/react';
import { useCopyToClipboard, useLocation } from 'react-use';
import { GroupDetails } from 'src/features/home/features/group/ui/group-details';
import { routes } from 'src/routes';
import { distributeGroupFx, group$, updateGroupFx } from 'src/store/group.store';

const Form = styled.div`
	display: grid;
	grid-template-columns: 1fr;
	grid-row-gap: 16px;
	justify-content: flex-end;
`;
const ButtonContainer = styled.div`
	display: flex;
	align-items: center;
	justify-content: flex-end;
`;

const updateGroupForm$ = createForm({
	fields: {
		caption: {
			init: '',
		},
		description: {
			init: '',
		},
	},
});

export const GroupAdminPage = () => {
	const group = useStore(group$);
	const updateForm = useForm(updateGroupForm$);
	const [_, copy] = useCopyToClipboard();
	const location = useLocation();

	useEffect(() => {
		updateForm.setForm({
			caption: group?.caption,
			description: group?.description,
		});
	}, [group]);

	return (
		<>
			<Form>
				<FormField label={'Title'}>
					<TextInput
						value={updateForm.values.caption}
						onChange={(e: ChangeEvent<HTMLInputElement>) => updateForm.fields.caption.onChange(e.target.value)}
						width={'100%'}
                        className={'inputstyle'}
					/>
				</FormField>
				<FormField label={'Description'}>
					<Textarea
						value={updateForm.values.description}
						onChange={(e: ChangeEvent<HTMLTextAreaElement>) => updateForm.fields.description.onChange(e.target.value)}
						width={'100%'}
                        className={'inputstyle'}
					/>
				</FormField>
				<ButtonContainer>
					{group?.distributed && (
						<a
							target={'_blank'}
							href={`https://vladisslava-boxes-app.s3.eu-central-1.amazonaws.com/stats/${group.id}.json`}
							style={{ marginRight: 'auto' }}
						>
							Stats
						</a>
					)}
					<Button
						marginRight={24}
						disabled={group?.distributed}
						onClick={async () => {
							await distributeGroupFx();
							toaster.success('Group distributed');
						}}
					>
						Distribute
					</Button>
					<Button
						appearance={'primary'}
						disabled={group?.distributed}
						onClick={() => {
							updateGroupFx(updateForm.values);
						}}
					>
						Save
					</Button>
				</ButtonContainer>
				<div>
					<Button
						appearance={'primary'}
						onClick={() => {
							const url = [
								location.protocol,
								location.host,
								routes.root.home.group
									.url(group?.id || ''),
							].join('');
							copy(url);
							toaster.notify('Copied')
						}}
					>
						Copy box link
					</Button>
				</div>
				<div style={{ marginTop: 32 }}>
					<GroupDetails/>
				</div>
			</Form>
		</>
	);
};
